import cx from 'classnames'
import Styles from './BottomMessage.module.scss'
import { Layer } from '../../types'
import { DeleteLayerButton } from './DeleteLayerButton'

interface Props {
  layer: Layer
}

export const LayerDeleteCompleteMessage = ({ layer }: Props) => (
  <div className={cx(Styles.messageContainer, Styles.finished)}>
    <div className={Styles.emoji}>✨</div>
    <div className={Styles.message}>
      <div>You are all done!</div>
      <span>You can now safely delete the layer</span>
    </div>
    <DeleteLayerButton layer={layer} />
  </div>
)
